import { Route } from "vue-router";
import store from "@/store";
import { safeGetItem } from "@/helpers/safeLocalStorage";

export const redirectMfaRoute = async function(
  this: any,
  toRoute: Route,
  fromRoute: Route,
  next: any
): Promise<void> {
  // If not login path, continue
  if (!toRoute.path.includes("/mfa")) {
    return next();
  }

  const hasToken = safeGetItem("auth_mfa_request");
  if (!hasToken) {
    return next("/login");
  }

  try {
    const success = await store.dispatch("auth/authCheckMfaRequest");
    this.mfaOptions = success;
    return next();
  } catch (error) {
    return next("/login");
  }
};
